import { FC, ReactNode } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import { AuthGuard_data$key } from '__generated__/AuthGuard_data.graphql';

type Props = {
  data: AuthGuard_data$key;
  loginComponent: ReactNode;
};

export const AuthGuard: FC<Props> = props => {
  const { loginComponent, children } = props;

  const { viewer } = useFragment(
    graphql`
      fragment AuthGuard_data on Query {
        viewer {
          name
        }
      }
    `,
    props.data
  );

  return viewer ? (children as any) : loginComponent;
};

export default AuthGuard;
